import useResource from "./useResource";
import { convertToCamelCase } from "../helpers/utils";
import { Pages } from "../constants/enums";
import { Token } from "../models/pagination";
import useAuth from "./useAuth";
import useAdmin from "./useAdmin";

const useListings = (slug: string) => {
  const resource = useResource();
  const { login, register, forgetPassword, forgetPasswordSubmit } = useAuth();
  const { adminsCreate, adminsDisableUser } = useAdmin("admins", "admin");

  const api: any = {};
  const defaultListing: any[] = [];
  const defaultOptions: any[] = [];
  const defaultHeadCells: any[] = [];
  const defaultDataCells: any[] = [];
  const defaultSearchText: string = "";
  const defaultSearchListing = (searchText: string) => {};
  const defaultFetchListing = (
    limit: number,
    nextToken: Token,
    setNextNextToken: any
  ) => {};
  const defaultChangeListing = (listing: any[]) =>
    {};
  const defaultGetResource = (id: string) =>
    {};
  const defaultCreateResource = (data: any, state: any) =>
    {};
  const defaultUpdateResource = (id: string, data: any, state: any) =>
    {};
  const defaultTrashResource = (id: string) =>
    {};
  const defaultBulkTrashResource = (ids: any) => {};
  const defaultDeleteResource = (id: string) => {};
  const defaultExportResource = () => {};

  for (let page of Object.values(Pages)) {
    if (slug === page) {
      if (slug === Pages.CREDIT_NOTES) {
        page = Pages.INVOICES;
      }
      if (slug === Pages.Zacta_CREDIT_NOTES) {
        page = Pages.ZactaINVOICES;
      }
      if (slug === Pages.ADMINS) {
        api.createResource = adminsCreate;
        api.listing = [];
        api.deleteResource = defaultDeleteResource;
        api.trashResource = adminsDisableUser;
      } else if (slug === Pages.LOGIN) {
        api.createResource = login;
      } else if (slug === Pages.REGISTER) {
        api.createResource = register;
      } else if (slug === Pages.FORGOT_PASSWORD) {
        api.createResource = forgetPassword;
      } else if (slug === Pages.RESET_PASSWORD) {
        api.createResource = forgetPasswordSubmit;
      } else {
        api.listing =
          resource[`${convertToCamelCase(page)}Listing`] !== undefined
            ? resource[`${convertToCamelCase(page)}Listing`]
            : defaultListing;
        api.options =
          resource[`${convertToCamelCase(page)}Options`] !== undefined
            ? resource[`${convertToCamelCase(page)}Options`]
            : defaultOptions;
        api.headCells =
          resource[`${convertToCamelCase(page)}HeadCells`] !== undefined
            ? resource[`${convertToCamelCase(page)}HeadCells`]
            : defaultHeadCells;
        api.dataCells =
          resource[`${convertToCamelCase(page)}DataCells`] !== undefined
            ? resource[`${convertToCamelCase(page)}DataCells`]
            : defaultDataCells;
        api.searchText =
          resource[`${convertToCamelCase(page)}SearchText`] !== undefined
            ? resource[`${convertToCamelCase(page)}SearchText`]
            : defaultSearchText;
        api.changeListings =
          resource[`${convertToCamelCase(page)}ChangeListing`] !== undefined
            ? resource[`${convertToCamelCase(page)}ChangeListing`]
            : defaultChangeListing;
        api.fetchListings =
          resource[`${convertToCamelCase(page)}Fetch`] !== undefined
            ? resource[`${convertToCamelCase(page)}Fetch`]
            : defaultFetchListing;
        api.searchListings =
          resource[`${convertToCamelCase(page)}Search`] !== undefined
            ? resource[`${convertToCamelCase(page)}Search`]
            : defaultSearchListing;
        api.getResource =
          resource[`${convertToCamelCase(page)}Get`] !== undefined
            ? resource[`${convertToCamelCase(page)}Get`]
            : defaultGetResource;
        api.createResource =
          resource[`${convertToCamelCase(page)}Create`] !== undefined
            ? resource[`${convertToCamelCase(page)}Create`]
            : defaultCreateResource;
        api.updateResource =
          resource[`${convertToCamelCase(page)}Update`] !== undefined
            ? resource[`${convertToCamelCase(page)}Update`]
            : defaultUpdateResource;
        api.trashResource =
          resource[`${convertToCamelCase(page)}Trash`] !== undefined
            ? resource[`${convertToCamelCase(page)}Trash`]
            : defaultTrashResource;
        api.bulkTrashResource =
          resource[`${convertToCamelCase(page)}BulkTrash`] !== undefined
            ? resource[`${convertToCamelCase(page)}BulkTrash`]
            : defaultBulkTrashResource;
        api.deleteResource =
          resource[`${convertToCamelCase(page)}Delete`] !== undefined
            ? resource[`${convertToCamelCase(page)}Delete`]
            : defaultDeleteResource;
        api.exportResource =
          resource[`${convertToCamelCase(page)}Export`] !== undefined
            ? resource[`${convertToCamelCase(page)}Export`]
            : defaultExportResource;
        api.resourceModel =
          resource[`${convertToCamelCase(page)}Model`] !== undefined
            ? resource[`${convertToCamelCase(page)}Model`]
            : null;
        api.ImportData =
          resource[`${convertToCamelCase(page)}ImportData`] !== undefined
            ? resource[`${convertToCamelCase(page)}ImportData`]
            : null;
      }
    }
  }

  return api;
};

export default useListings;
